import { useApi } from '@prismo-io/core';
import type { SWRArgs } from '@prismo-io/schemas';
import useSWRMutation from 'swr/mutation';
import { type ParamsSchemaT, sendSkill } from '../utils/send-skill';
export function useSendSkill() {
  const {
    client
  } = useApi();
  return useSWRMutation('send-quark-skill', (key, {
    arg
  }: SWRArgs<ParamsSchemaT>) => {
    return sendSkill(client, arg);
  });
}